import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sign-up-completed',
  templateUrl: './sign-up-completed.component.html',
  styleUrls: ['./sign-up-completed.component.scss']
})
export class SignUpCompletedComponent implements OnInit {
  clientId;
  sectionTitle = 'Please check your email'
  SUCompletedInfo = {
    mailSent: "We've sent an email confirming your account to:",
    mail: 'test@test.com',
    checkSpam: "If you don't receive the email within a couple minutes, then please check your spam folder.",
    resendMail: "Resend confirmation email"
  }

  constructor(private router: Router,private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.clientId = this.activatedRoute.snapshot.paramMap.get("id")
  }
  goto(url: string) {
    this.router.navigate(['/' + url]);
  }
}
